import { useCallback, useState } from "react"

import { SignupModal } from "@/components/SignupModal"
import { UpgradeModal } from "@/components/UpgradeModal"

interface UseOperationGuardOptions {
  dailyRemaining: number
  authenticated: boolean
}

export function useOperationGuard({
  dailyRemaining,
  authenticated,
}: UseOperationGuardOptions) {
  const [completed, setCompleted] = useState(false)
  const [remainingOperations, setRemainingOperations] = useState(dailyRemaining)
  const [showSignupModal, setShowSignupModal] = useState(false)
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  const guardOperation = useCallback((): boolean => {
    if (!authenticated) {
      setShowSignupModal(true)
      return false
    }

    if (remainingOperations <= 0 && !completed) {
      setShowUpgradeModal(true)
      return false
    }

    return true
  }, [authenticated, remainingOperations, completed])

  const markCompleted = useCallback(() => {
    if (!completed) {
      setCompleted(true)
      setRemainingOperations((prev) => Math.max(0, prev - 1))
    }
  }, [completed])

  const Modals = useCallback(
    () => (
      <>
        <SignupModal open={showSignupModal} onOpenChange={setShowSignupModal} />
        <UpgradeModal
          open={showUpgradeModal}
          onOpenChange={setShowUpgradeModal}
        />
      </>
    ),
    [showSignupModal, showUpgradeModal],
  )

  return {
    remainingOperations,
    completed,
    guardOperation,
    markCompleted,
    Modals,
  }
}
